import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { Button, Checkbox, Dialog, FormControlLabel, TextField, Typography } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import API from 'app/API';
import Hubspot from 'app/main/common/Hubspot';
import useStores from 'hooks/use-stores';

const SignUp: React.FC = () => {
    const { dialogStore } = useStores();
    const { openLoginDialog, signupDialogOpen } = dialogStore;

    const [state, setState] = useState({
        email: '',
        password: '',
        repeatPassword: '',
        marketingAgreement: false,
        eula: true,

        errorText: '',
        emailError: '',
        successText: '',
        passwordError: '',
        passwordRepeatError: ''
    });

    const checkPassRepeat = (event) => {
        const pValue = state.password;
        const rpValue = event.target.value;
        setState((state) => ({
            ...state,
            passwordRepeatError: rpValue === pValue ? '' : 'Passwords are different'
        }));
    };

    const checkPassStrength = () =>
        API.fetch(API.CHECK_PASSWORD, {
            password: state.password
        }).then((response) => {
            const errors = Object.keys(response.data.improvements).map((k) => response.data.improvements[k]);
            setState((state) => ({
                ...state,
                passwordError: response.data.strenght > 0.5 ? '' : errors[0]
            }));
        });

    const checkEmail = () =>
        API.fetch(API.CHECK_EMAIL, {
            email: state.email
        }).then((response) => {
            setState((state) => ({
                ...state,
                emailError: response.result === 'OK' ? '' : response.data.error
            }));
        });

    const handleEmailChange = (event) => setState((state) => ({ ...state, email: event.target.value }));
    const handlePasswordChange = (event) => setState((state) => ({ ...state, password: event.target.value }));
    const handleRepeatPasswordChange = (event) =>
        setState((state) => ({ ...state, repeatPassword: event.target.value }));

    const handleMarketingAgreementChange = () => {
        setState((state) => ({ ...state, marketingAgreement: !state.marketingAgreement }));
    };

    const handleEulaChange = () => {
        setState((state) => ({ ...state, eula: !state.eula }));
    };

    const signUp = () => {
        const { email, password, marketingAgreement } = state;

        API.fetchWithToken(API.ADD, {
            email,
            password,
            marketingAgreement: +marketingAgreement
        }).then((response) => {
            setState((state) => ({
                ...state,
                errorText: response.result === 'error' ? response.data.error : '',
                successText: response.result === 'OK' ? 'User has been registered' : ''
            }));

            if (response.result === 'OK') {
                Hubspot.send(Hubspot.SIGNUP, { email });
                if (marketingAgreement) {
                    Hubspot.send(Hubspot.MARKETING_AGREEMENT, { email });
                }

                dialogStore.openMessageDialog(
                    'Activate your account',
                    'Message with account activation instructions was sent to your email'
                );
            }
        });
    };

    return (
        <Dialog maxWidth="xs" open={signupDialogOpen} className="vulners-dialog" onClose={openLoginDialog}>
            <DialogTitle>{'Sign Up to Vulners'}</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    name="email"
                    label="Email"
                    onBlur={checkEmail}
                    onChange={handleEmailChange}
                    error={!!state.emailError}
                    helperText={state.emailError}
                />
                <br />
                <TextField
                    fullWidth
                    name="password"
                    type="password"
                    label="Password"
                    onChange={handlePasswordChange}
                    onBlur={checkPassStrength}
                    error={!!state.passwordError}
                    helperText={state.passwordError}
                />
                <br />
                <TextField
                    fullWidth
                    type="password"
                    name="repeatPassword"
                    label="Repeat Password"
                    onChange={(event) => {
                        handleRepeatPasswordChange(event);
                        checkPassRepeat(event);
                    }}
                    onBlur={handleRepeatPasswordChange}
                    error={!!state.passwordRepeatError}
                    helperText={state.passwordRepeatError}
                />
                <br />
                <FormControlLabel
                    control={<Checkbox checked={state.eula} onChange={handleEulaChange} name="elua" color="primary" />}
                    label={
                        <Typography variant="body2">
                            {'I agree to the Vulners '}
                            <Typography
                                variant="body2"
                                gutterBottom
                                component="a"
                                color="primary"
                                href="static/docs/eula.pdf"
                                target="_blank"
                            >
                                {'End of User License Agreement'}
                            </Typography>
                        </Typography>
                    }
                />
                <br />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={state.marketingAgreement}
                            onChange={handleMarketingAgreementChange}
                            name="marketingAgreement"
                            color="primary"
                        />
                    }
                    label={
                        <Typography variant="body2">
                            {'I would like to receive newsletter in accordance with our '}
                            <Typography
                                variant="body2"
                                gutterBottom
                                component="a"
                                color="primary"
                                href="/static/docs/privacy_policy.html"
                                target="_blank"
                            >
                                {'Privacy Policy'}
                            </Typography>
                        </Typography>
                    }
                />
                <br />
                <div className="vulners-dialog-error-text">{state.errorText}</div>
                <div className="vulners-dialog-success-text">{state.successText}</div>
                <Button disabled={!state.eula} fullWidth color="primary" variant="contained" onClick={signUp}>
                    {'Sign Up'}
                </Button>
                <br />
            </DialogContent>
        </Dialog>
    );
};
export default observer(SignUp);
